import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

export const qceQualificationScoresFields: FieldInterface[] = [
  {
    key: 'kind',
    originKey: 'kind',
    type: FIELD_TYPES.string,
  },
  {
    key: 'score',
    originKey: 'score',
    type: FIELD_TYPES.string,
  },
  {
    key: 'label',
    originKey: 'label',
    type: FIELD_TYPES.string,
  },
  {
    key: 'altLabel',
    originKey: 'alt_label',
    type: FIELD_TYPES.string,
  },
  {
    key: 'description',
    originKey: 'description',
    type: FIELD_TYPES.string,
  },
  {
    key: 'extra',
    originKey: 'extra',
    type: FIELD_TYPES.string,
  },
]

export const qceQualificationScoresRelations: RelationInterface[] = []
